/* eslint max-len: 0 */

import { RecommendationsRepository, ActivationCodesRepository, AppIntegrationsRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import eventManager from 'common/services/-RFC.eventManager';

const _directiveDependencies = [];
const _controllerDependencies = ['$state', 'Util', '$scope', '$rootScope'];

class OneClickPaymentButtonController {

    constructor($state, Util, $scope, $rootScope) {

        this.$state = $state;
        this.$scope = $scope;
        this.Util = Util;
        this.$rootScope = $rootScope;

        $scope.showRecommendation = false;
        const subscriptions = ActivationCodesRepository.getAll();

        $scope.showLearnMoreButton = true;

        if (this.$scope.productid === 'aps10') {

            // hide the learn more button for app recommendations without comparison features
            const currentUserAppId = Util.deepFind(subscriptions[0], 'attributes.app');
            const recommendedApp = AppIntegrationsRepository.getById(currentUserAppId) || {};

            if (!Util.deepFind(recommendedApp, 'attributes.resource.comparisonFeatures')) {

                $scope.showLearnMoreButton = false;

            }

        }

        if (subscriptions.length > 0) {

            // get recommendation for user
            const recommendationObservable = RecommendationsRepository.getObservable();
            const recommendationsSubscriber = recommendationObservable.subscribe((data) => {

                // recommendation is available, show banner
                if (data.length > 0) {

                    this.recommendations = data;

                    // feature/OE-7610-a-b-test-aia-banner-copy-ocp
                    $scope.recommendationDetails = this.recommendations.find(recommendation => recommendation.attributes.acronym === $scope.productid);
                    // feature/OE-7610-a-b-test-aia-banner-copy-ocp

                    if ($scope.recommendationDetails) {

                        // show recommendation only for CB region. CA region (USA) is excluded
                        if ($scope.recommendationDetails.attributes.pg === 'CB' && $scope.productid === $scope.recommendationDetails.attributes.acronym
                            && $scope.runtime === '12' && $rootScope.hasValidPayment === true) {

                            $scope.showRecommendation = true;
                            eventManager.broadcast('showRecommendation:true');

                        }

                        $scope.recommendedProduct =
                            AppIntegrationsRepository.getById($scope.recommendationDetails.attributes.acronym);

                    }

                } else {

                    $scope.showRecommendation = false;
                    eventManager.broadcast('showRecommendation:false');

                }

            }, () => { }, () => { });

            $scope.$on('$destroy', () => {

                recommendationsSubscriber.dispose();

            });

        }
        $scope.$watch('runtime', () => {

            this.toggleOcpButton();

        });
        $scope.$watch('productid', () => {

            this.toggleOcpButton();

        });

    }

    toggleOcpButton() {

        const appId = this.Util.deepFind(this.$scope.recommendationDetails, 'attributes.acronym');
        if (this.$scope.runtime === '12' && this.$scope.productid === appId && this.$rootScope.hasValidPayment === true) {

            this.$scope.showRecommendation = true;
            eventManager.broadcast('showRecommendation:true');

        } else {

            this.$scope.showRecommendation = false;
            eventManager.broadcast('showRecommendation:false');

        }

    }

    tryRecommendation(action) {

        this.$rootScope.ocp_xa_content = this.$scope.xacontent;
        this.$rootScope.ocp_xa_medium = this.$scope.xamedium;
        this.$rootScope.ocp_xa_aiatest = this.$scope.xaaiatest;
        this.$rootScope.ocp_xa_button = this.$scope.xabutton;

        let ltbName = 'one-click-payment';
        let stateName = this.$state.current.name;

        if (stateName.indexOf('.ltb') === -1) {

            stateName += '.ltb';

        }

        // Learn More modal
        if (action === 'Learn More') {

            ltbName = 'ocp-comparison';

        }

        const mixpanelDetails = {
            Product: this.$scope.recommendedProduct.attributes.name,
            'Product ID': this.$scope.recommendedProduct.id,
            'Recommendation ID': this.$scope.recommendationDetails.id,
            'Button Label': action,
            Page: this.Util.capitalizeFirstLetter(this.$scope.page),
        };

        Mixpanel.send('ConnectWeb OCP Button Click', mixpanelDetails);

        // open modal
        this.$state.go(stateName, {
            ltb: ltbName,
            resourceId: this.$scope.recommendedProduct.id,
        }, {
            reload: false,
        });

    }

}

class OneClickPaymentButtonDirective {

    constructor() {

        this.template = `<div>
                            <button class={{classname}}
                                    ng-if="showRecommendation && action === 'Update'"
                                    connectqa-button="upgrade"
                                    ng-click="oneClickPaymentButtonController.tryRecommendation('Update')"
                                    translate={{translationkey}}>
                            </button>
                            <a class={{classname}}
                                    ng-if="showRecommendation && action === 'Learn More' && showLearnMoreButton"
                                    connectqa-button="upgrade"
                                    ng-click="oneClickPaymentButtonController.tryRecommendation('Learn More')"
                                    translate={{translationkey}}
                                    translate-values={{translationvalues}}>
                            </a>
                        </div>`;
        this.restrict = 'EA';
        this.replace = true;
        this.scope = {
            source: '=',
            licenses: '=',
            classname: '=',
            translationkey: '=',
            action: '=',
            translationvalues: '=',
            productid: '=',
            runtime: '=',
            page: '=',
            xacontent: '=',
            xamedium: '=',
            xaaiatest: '=',
            xabutton: '=',
        };

        if (CWCONFIG.features.oneClickPayment) {

            _controllerDependencies.push((
                $state, DeployRestService,
                Util, $scope, $rootScope,
            ) =>
                new OneClickPaymentButtonController(
                    $state, DeployRestService,
                    Util, $scope, $rootScope,
                ));
            this.controller = _controllerDependencies;
            this.controllerAs = 'oneClickPaymentButtonController';

        }
        eventManager.subscribe('runtime:changed', (data) => {

            this.scope.runtime = data.runtime;

        });
        eventManager.subscribe('product:changed', (data) => {

            this.scope.productid = data.activeProduct;

        });

    }

}

_directiveDependencies.push(() => new OneClickPaymentButtonDirective());


angular.module('directives')
    .directive('ocpButton', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/ocp-button.js